module.exports = __webpack_public_path__ + "static/img/default-icon-64.6851cbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default-icon-64.png
// module id = e8Ao
// module chunks = 33